export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_MESSAGING_SENDER_ID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
export const AUTH_ACTION_RESET_PW = 'resetPassword';
export const AUTH_ACTION_RECOVER_EMAIL = 'recoverEmail';
export const AUTH_ACTION_VERIFY_EMAIL = 'verifyEmail';
